import { Link } from "@jetblue/dotcom-components/link";
import type { TrueBlueUserProperties } from "./true-blue-user";
import type { EnhancedUserData } from "@jetblue/dotcom-auth";

export type CreditProfileUserProperties = {
  cta?:
    | {
        href?: string | undefined;
        isExternal?: boolean;
        label?: string | undefined;
        target?: "_blank" | "_self" | undefined;
      }
    | undefined;
  firstName: string;
  labels: { travelCredits: string };
  loyalty: TrueBlueUserProperties["loyalty"];
  travelBankDetails: EnhancedUserData["travelBankDetails"];
};
export const CreditProfileUser = ({
  cta: { href = "", isExternal = false, label = "", target = "_self" } = {},
  firstName,
  labels,
  loyalty,
  travelBankDetails,
}: CreditProfileUserProperties) => (
  <section
    className="
      bg-background-surface-variant-low p-6 text-foreground-primary-variant

      data-[theme=dark]:bg-background-primary-variant
      data-[theme=dark]:text-foreground-on-primary
    "
    data-fs-element="user-credit-profile-details-section"
    data-theme={loyalty.theme}
  >
    <div className="mb-2 text-center text-body font-extrabold">
      {loyalty.labels.greeting}&nbsp;
      {firstName}
    </div>

    <div className="mt-3 text-center text-foreground-on-surface">
      <div className="text-center text-caption">
        <div className="text-caption">{labels.travelCredits}</div>

        <div className="text-body font-extrabold">
          {travelBankDetails?.balance?.amount}
        </div>
      </div>
    </div>

    {href && label && (
      <div className="mt-2 flex justify-center text-foreground-on-surface">
        <Link
          className="
            w-fit text-caption font-bold text-foreground-primary focus-outline

            hover:text-foreground-primary-variant hover:underline
          "
          data-fs-element="user-credit-profile-details-cta-link"
          href={href}
          isExternal={isExternal}
          showArrowRight
          target={target}
        >
          {label}
        </Link>
      </div>
    )}
  </section>
);
